import React from 'react';

const ArticleWrapper = ({children}) => {
    return <article>{children}</article>;
};

export default ArticleWrapper;
